import { render, staticRenderFns } from "./PosterEdit.vue?vue&type=template&id=35b26f42&scoped=true&"
import script from "./PosterEdit.vue?vue&type=script&lang=js&"
export * from "./PosterEdit.vue?vue&type=script&lang=js&"
import style0 from "./PosterEdit.vue?vue&type=style&index=0&id=35b26f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b26f42",
  null
  
)

export default component.exports